/**
 * @generated SignedSource<<2ffdfed466dd9dad9f59e3b21106154a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddressEditInfo$data = {
  readonly buildingName: string | null;
  readonly cityName: string | null;
  readonly postalCode: string | null;
  readonly prefectureName: string | null;
  readonly townName: string | null;
  readonly " $fragmentType": "AddressEditInfo";
};
export type AddressEditInfo$key = {
  readonly " $data"?: AddressEditInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddressEditInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddressEditInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefectureName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cityName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "townName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buildingName",
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "042749c048905281154444a721f181fc";

export default node;
